import { StatesType } from '../types';

export const states: StatesType = {
  pending: 'pending',
  error: 'error',
  ok: 'ok'
};
